import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Avatar, Typography } from 'shared/ui'
import { getLabelAsNumberInternationalFormat } from 'shared/lib'
import { type CallHistory } from 'entities/CallHistory/model/CallHistory'
import { ConversationCall } from 'entities/Conversation/actions/ConversationCall/ConversationCall'
import { CellContactUi } from 'pages/conversations/pages/calls/ui/CallHistoryTable/ui/CellContact/CellContactUi/CellContactUi'

type ICellContactProps = {
  info: CallHistory
  showActions?: boolean
  withPhoneContent?: boolean
  withCalls?: boolean
}
export const CellContact: FC<ICellContactProps> = observer(
  ({ info, showActions, withCalls, withPhoneContent }) => {
    const label =
      (info?.contact?.number && getLabelAsNumberInternationalFormat(info.contact.number)) ?? ''

    const avatarContent = (
      <>
        {info.participants?.length ? (
          <Avatar info={info.participantsAvatarInfo} size={24} />
        ) : (
          info.contact && <Avatar info={info.contactAvatarInfo} size={24} />
        )}
      </>
    )

    const nameContent = (
      <>
        {info.participants?.length ? (
          <Typography
            variant={info.isUnread ? 'body-md-semibold' : 'body-rg-regular'}
            ellipsis
            tooltipProps={{
              label: 'Participants',
            }}
            ariaLabel={'user'}
          >
            {info.participants?.map((participant, index) => {
              if (info.participants && index === info.participants.length - 1)
                return <span key={index}>{participant.name}</span>

              return <span key={index}>{participant.name}, </span>
            })}
          </Typography>
        ) : (
          !!info.contact && (
            <Typography
              variant={info.isUnread ? 'body-md-semibold' : 'body-rg-regular'}
              ellipsis
              tooltipProps={{
                label: info.contact.name || label,
              }}
              ariaLabel={'user'}
            >
              {info.contact.name || label}
            </Typography>
          )
        )}
      </>
    )
    const phoneContent = withPhoneContent && !info.contact?.name && info.contact?.number && (
      <Typography
        variant={'body-xs-regular'}
        color={'tertiary'}
        ellipsis
        tooltipProps={{
          label: label,
        }}
        ariaLabel={'phone'}
      >
        {label}
      </Typography>
    )

    const callAction = withCalls && (
      <ConversationCall
        conversationId={info.conversation.id}
        inboxId={info.inbox.id}
        contactId={info.contact?.id}
      />
    )

    return (
      <CellContactUi
        callHistory={info}
        nameContent={nameContent}
        showActions={showActions}
        avatarContent={avatarContent}
        phoneContent={phoneContent}
        callAction={callAction}
      />
    )
  }
)
